function changeBasicField( state, action ) {
	let endpoints = state.settings.endpoints;

	if ( action.payLoad.fieldName === 'enabled' ) {
		endpoints = endpoints.map(endpoint => {
			endpoint.opacity = action.payLoad.fieldValue ? 1 : 0.5;
			endpoint.enabled = action.payLoad.fieldValue;
			return endpoint;
		});
	}

	return {
		...state,
		settings: {
			...state.settings,
			endpoints: endpoints,
			[action.payLoad.fieldName]: action.payLoad.fieldValue
		}
	};
}

function changeMainField( state, action ) {
	return {
		...state,
		[action.payLoad.name]: action.payLoad.value
	};
}

export { changeBasicField, changeMainField };